module.exports = __webpack_public_path__ + "assets/register_right.b9068a79.svg";